import { render, staticRenderFns } from "./btn-hamburger-primary.vue?vue&type=template&id=563b75ea&scoped=true&"
import script from "./btn-hamburger-primary.vue?vue&type=script&lang=js&"
export * from "./btn-hamburger-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b75ea",
  null
  
)

export default component.exports